// extracted by mini-css-extract-plugin
export default {"self":"CheckoutProgress_self__UGRm9"};